import React from "react";
import { Container } from "react-bootstrap";
import FramerSection from "./FarmaerSection/FramerSection";
import HeroSection from "./HeroSection/HeroSection";
import "./Home.css"
import ProductSection from "./ProductSection/ProductSection";

const Home = () => {
  return (
    <>
      {/* Hero Section */}
      <Container fluid className="p-0">
        <HeroSection></HeroSection>
      </Container>
      <Container fluid className="mb-5 p-0">
        <FramerSection></FramerSection>
      </Container>
      <Container fluid className="mb-5 p-0">
        <ProductSection></ProductSection>
      </Container>
      
    </>
  );
};

export default Home;
